import PageLayer from "@/Layouts/views/PageLayer";
import Icon from "@/User/assets/icons/person-circle.svg";
import UserProfileContainer from "@/User/components/UserProfile/UserProfileContainer";

export default function UserProfileView() {
	return (
		<PageLayer title="User Profile" icon={Icon}>
			<UserProfileContainer />
		</PageLayer>
	);
}
